export default [
  {
    name: ' ',
    icon: 'mdi-bell-outline',
    path: '/notifications',
    beforeEnter: (to, from, next) => {
      window.location.href = '/v2/notificaciones';
    },
    component: () =>
      import(/* webpackChunkName: "admin-broadcast-messages" */ './views/NotificationList.vue'),
    meta: {
      admin: false,
      toolbar: true,
      adminToolbar: false,
      adminDrawer: false,
      rightToolbar: true,
      tooltip: null,
      badge: true,
      badgeChecker: 'userBroadcastMessagesReady',
      badgeContent: 'unreadedUserBroadcastMessages',
    },
  },
  {
    name: 'notification-details',
    icon: 'mdi-bell-outline',
    path: '/notifications/:id',
    beforeEnter: (to, from, next) => {
      window.location.href = '/v2/notificaciones';
    },
    props: true,
    component: () =>
      import(/* webpackChunkName: "admin-broadcast-messages" */ './views/NotificationDetails.vue'),
    meta: {
      admin: false,
      toolbar: false,
      adminToolbar: false,
      adminDrawer: false,
      rightToolbar: false,
    },
  },
];
